import React from "react"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import { data } from "../../../../data/nsf"

const NSFCertificationBanner = () => {
  const {
    banner: { heading, copy, button, image },
  } = data

  return (
    <section className="bg-nova-base-solid-10 px-6 sm:px-8 py-10 sm:py-12 lg:py-20">
      <div className="max-w-[1376px] mx-auto flex flex-col items-center gap-10 lg:gap-20">
        <div>
          <TextElementNova
            element={`h2`}
            className="Title-20-Super-Normal text-center"
            text={heading}
          />
        </div>
        <div
          className={`flex gap-6 sm:gap-10 lg:gap-20  sm:px-8 lg:px-10 items-center`}
        >
          <div>
            <img
              src={image}
              alt={``}
              role={`presentation`}
              className="max-w-[90px] sm:max-w-[98px] lg:max-w-[178px] "
            />
          </div>
          <div>
            <TextElementNova
              classes={{
                default: "Body-20-Dia-Normal",
                1280: "Body-30-Dia-Normal",
              }}
              text={copy}
            />
          </div>
        </div>
        <div>
          <ButtonNova
            ctaLink={button.link}
            label={button.text}
            icon={`Left`}
            level={"Tertiary"}
            trackObject={{
              destination: button.link,
              type: "button",
              text: button.text,
            }}
          />
        </div>
      </div>
    </section>
  )
}

export default NSFCertificationBanner
